__turbopack_context__.v({
  "impersonation-form": "_1pLgAW_impersonation-form",
  "impersonation-form__actions": "_1pLgAW_impersonation-form__actions",
  "impersonation-form__description": "_1pLgAW_impersonation-form__description",
});
